<template>
  <div>
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-notice-app-container-detail">
      <div class="ccui-notice-app-container-detail-body clearfix">
        <div class="ccui-notice-app-container-detail-left">
          <div class="notice-title">{{ schemeObj.schemeName }}</div>
          <div class="notice-project-info">
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.projectCode") }}：</span
              >{{ schemeObj.schemeCode }}
            </div>
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.publishTime") }}：</span
              >{{ schemeObj.noticeStartTime }}
            </div>
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.publishUnit") }}：</span
              >{{ schemeObj.opUnitName }}
            </div>
          </div>
        </div>
        <div class="ccui-notice-app-container-detail-right">
          <template v-if="schemeObj.isNotShowTime == '1'">
            <div class="notice-timeout-label">
              {{ $t("page.content.signUpEndTime") }}
            </div>
            <div class="notice-timeout-value">
              <i class="el-icon-time notice-icon-time"></i
              ><span class="time">{{ timeObj.day }}</span
              >{{ $t("page.content.day")
              }}<span class="time">{{ timeObj.hour }}</span
              >{{ $t("page.content.hour")
              }}<span class="time">{{ timeObj.minute }}</span
              >{{ $t("page.content.minute")
              }}<span class="time">{{ timeObj.second }}</span
              >{{ $t("page.content.second") }}
            </div>
          </template>
          <!-- <el-button
            class="notice-timeout-btn"
            :disabled="
              this.$route_query.schemeStatus !== '3' ||
                (this.checkFlag !== '2' &&
                  this.checkFlag !== '4' &&
                  this.checkFlag !== '5')
            "
            size="mini"
            type="primary-font-mini"
            @click="
              signUp({
                schemeId: $route.query.schemeId,
                purchaseType: $route.query.purchaseType,
                noticeStartTime: schemeObj.noticeStartTime,
                schemeCode: schemeObj.schemeCode,
                schemeName: schemeObj.schemeName,
                supName: $route.query.supName,
                supCode: $route.query.supCode
              })
            "
            >{{ $t("page.content.immediatelySignUp") }}</el-button
          > -->
          <template>
            <el-button
              :class="[
                'notice-timeout-btn',
                schemeObj.isNotShowTime == '1'
                  ? 'notice-timeout-btn-bottom'
                  : ''
              ]"
              size="mini"
              type="primary-font-mini"
              v-if="
                !(
                  this.$route_query.schemeStatus !== '3' ||
                  (this.checkFlag !== '2' &&
                    this.checkFlag !== '4' &&
                    this.checkFlag !== '5')
                )
              "
              @click="
                signUp({
                  schemeId: $route_query.schemeId,
                  purchaseType: $route_query.purchaseType,
                  noticeStartTime: schemeObj.noticeStartTime,
                  schemeCode: schemeObj.schemeCode,
                  schemeName: schemeObj.schemeName,
                  supName: $route_query.supName,
                  supCode: $route_query.supCode
                })
              "
              >{{ $t("page.content.immediatelySignUp") }}</el-button
            >
            <!--进入项目-->
            <template
              v-else-if="this.checkFlag !== '1' && this.checkFlag !== '4'"
            >
              <el-button
                :class="[
                  'notice-timeout-btn',
                  schemeObj.isNotShowTime == '1'
                    ? 'notice-timeout-btn-bottom-project'
                    : ''
                ]"
                size="mini"
                type="primary-font-mini"
                @click="
                  toProject({
                    schemeId: $route_query.schemeId,
                    purchaseType: $route_query.purchaseType,
                    noticeStartTime: schemeObj.noticeStartTime,
                    noticeEndTime: schemeObj.noticeEndTime,
                    schemeCode: schemeObj.schemeCode,
                    schemeName: schemeObj.schemeName,
                    supName: $route_query.supName,
                    supCode: $route_query.supCode
                  })
                "
                >{{ $t("page.content.toMyProject") }}</el-button
              >
            </template>
            <template v-else>
              <el-button
                :class="[
                  'notice-timeout-btn',
                  schemeObj.isNotShowTime == '1'
                    ? 'notice-timeout-btn-bottom'
                    : ''
                ]"
                size="mini"
                type="primary-font-mini"
                :disabled="true"
                >{{ $t("page.content.immediatelySignUp") }}</el-button
              >
            </template>
          </template>
        </div>
      </div>
    </div>
    <div class="template-notice-detail-body ccui-clearfix">
      <!--左侧内容-->
      <div
        class="template-notice-detail-left"
        :style="{
          'min-height': leftMinHeight
        }"
      >
        <div class="notice-detail-title">{{ $t("page.content.notice") }}</div>
        <div class="notice-detail-ul clearfix">
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title"
              >{{ $t("page.content.noticeTitle") }}：</span
            >
            <div class="notice-detail-li-con">{{ pageData.noticeTitle }}</div>
          </div>
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title"
              >{{ $t("page.content.noticeContent") }}：</span
            >
            <div class="notice-detail-li-con" v-html="pageData.textInfo"></div>
          </div>
          <!-- <div
            class="notice-detail-li ccui-clearfix"
            v-if="
              $route.query.purchaseType === '0' ||
                $route.query.purchaseType === '3'
            "
          >
            <span class="notice-detail-li-title"
              >{{ $t("page.content.contractInfo") }}：</span
            >
            <div class="notice-detail-li-con" v-html="pageData.linkInfo"></div>
          </div> -->
        </div>
        <div class="notice-detail-title" style="padding-top: 40px">
          {{ $t("page.content.fileList") }}
          <span class="notice-detail-title-tip">
            <el-link type="danger" @click="handleProcess">{{
              $t("page.content.supplierBiddingProcess")
            }}</el-link>
            <span class="fontsize-14"
              >（{{ $t("page.content.pleaseClickView") }}）</span
            >
          </span>
        </div>

        <detailTable
          class="dic-sub-table-style01"
          :tableData="pageData.fileinfoBOS"
          :tableHead="fileHead"
          :showIndex="true"
        ></detailTable>

        <div>
          <!--包件信息-->
          <template v-for="(item, index) in packageList">
            <div :key="index">
              <template v-if="subPackageFlag === '1'">
                <div
                  class="notice-detail-title mt20 ellipsis"
                  :title="item.packName"
                >
                  {{ item.packName }}
                </div>
                <!-- <div class="notice-detail-explain ccui-clearfix">
                  <div class="fl">{{ $t("page.content.packageDesc") }}：</div>
                  <div style="line-break: anywhere;">
                    {{ item.packRequire }}
                  </div>
                </div> -->
              </template>
              <div class="notice-detail-title pt20" v-else></div>
              <template v-if="item.matDetailList.length > 0">
                <div class="notice-detail-subtitle">
                  {{ $t("page.content.quantitiesInfo") }}
                </div>
                <detailTable
                  class="dic-sub-table-style01"
                  :tableData="item.matDetailList"
                  :tableHead="packageHead"
                  :showIndex="true"
                ></detailTable>
              </template>
            </div>
          </template>
        </div>
        <div class="notice-detail-title pt20">
          {{ $t("page.content.relatedNoticeList") }}
        </div>
        <detailTable
          class="dic-sub-table-style01"
          :tableData="relateNoticeList"
          :tableHead="noticeHead"
          :showIndex="true"
        >
          <template slot="noticeTitle" slot-scope="{ row }">
            <el-button size="mini" type="text" @click="handleNoticeTitle(row)">
              {{ row.noticeTitle }}
            </el-button>
          </template>
        </detailTable>
      </div>

      <!--右侧内容 不显示了，查的数据不对-->
      <!-- <div v-if="false" class="template-notice-detail-right" ref="rightBox">
        <div class="detail-info-right-box">
          <div class="logo-detail">
            <img
              :src="require('@/basa/assets/images/littleLogo.png')"
              class="svg-icon"
            />
            <div class="detail-info-right-box-title">
              {{ schemeObj.opUnitName }}
            </div>
          </div>
          <el-divider></el-divider>
          <div class="detail-info-right-box-subtitle">
            {{ $t("page.content.purchaseMoney") }}
          </div>
          <div class="detail-info-right-box-subbox clearfix">
            <span class="purchase-money ellipsis" :title="cumulativeAmount">{{
              cumulativeAmount
            }}</span
            ><span
              class="purchase-money-unit ell"
              :title="$t('page.content.thousandYuan')"
              >{{ $t("page.content.thousandYuan") }}</span
            >
          </div>
          <div class="detail-info-right-box-total clearfix">
            <div class="detail-info-right-box-total-label ell">
              {{ $t("page.content.camulativePurchaseItems") }}
            </div>
            <div class="detail-info-right-box-total-value">
              {{ projectNum }} 个
            </div>
          </div>

          <div class="detail-info-right-box-total clearfix">
            <div class="detail-info-right-box-total-label ell">
              {{ $t("page.content.inquiryProjectNum") }}
            </div>
            <div class="detail-info-right-box-total-value">
              {{ inquiryProjectNum }} 个
            </div>
          </div>

          <div class="detail-info-right-box-total clearfix">
            <div class="detail-info-right-box-total-label ell">
              {{ $t("page.content.biddingProjectNum") }}
            </div>
            <div class="detail-info-right-box-total-value">
              {{ competeProjectNum }} 个
            </div>
          </div>
        </div>

        <div class="detail-info-right-other" v-if="otherNoticeList.length > 0">
          <div class="detail-info-right-title ccui-clearfix">
            <span class="fl">{{ $t("page.content.unitStillPurchase") }}</span>
            <a class="fr" @click="handleViewCommendUnit(propsCode)"
              >{{ $t("page.content.MoreAndMore") }} ></a
            >
          </div>
          <template v-for="(item, index) in otherNoticeList">
            <div
              class="detail-info-right-other-box notice-detail-box-out"
              :key="index"
              @click="handleView(item)"
            >
              <notice-item-block :data="item"></notice-item-block>
            </div>
          </template>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import detailTable from "@/app/shop/components/detail-table";
import { commonTableWidth } from "@/setting/setting";
// import noticeItemBlock from "@/app/shop/components/noticeItemBlock";
import { mixinHomePage } from "../../../mixins/mixin-common/mixin-homePage";
import globalConfig from "@/setting/setting";
import {
  qryNoticeDetail,
  queryProcessSchemeMatDetail,
  qryRelatedNoticeList,
  // qryUnitAmountAndProjectNum,
  // listOpUnitBidNotice,
  qrySupJoinCheck
} from "@/app/shop/api/shopping";
export default {
  name: "noticeDetail",
  mixins: [mixinHomePage],
  components: {
    baseBreadCrumb,
    detailTable
    // noticeItemBlock,
  },
  data() {
    return {
      currBreadCrumb: [],
      propsCode: this.$route_query.supCode,
      fileHead: [
        { label: this.$t("page.content.fileName"), prop: "fileName" },
        {
          label: this.$t("page.content.fileSize"),
          prop: "fileSize",
          slot: "fileSize"
        },
        { label: this.$t("page.content.fileDesc"), prop: "fileSumm" },
        {
          label: this.$t("page.content.operation"),
          slot: "opp",
          align: "center"
        }
      ],
      packageHead: [
        { label: this.$t("page.content.code"), prop: "engerCode" },
        { label: this.$t("page.content.name"), prop: "engerName" },
        {
          label: this.$t("page.content.quantities"),
          prop: "quantities",
          slot: "quantities"
        },
        // { label: this.$t("page.content.unit"), prop: "unitName" },
        { label: this.$t("page.content.featRemark"), prop: "featRemark" },
        { label: this.$t("page.content.remark"), prop: "remark" }
      ],
      noticeHead: [
        {
          label: this.$t("page.content.type"),
          prop: "noticeTypeName",
          width: 150
        },
        {
          label: this.$t("page.content.title"),
          prop: "noticeTitle",
          slot: "noticeTitle"
        },
        // {
        //   label: this.$t("page.content.link"),
        //   prop: "purStepName",
        //   width: 150
        // },
        {
          label: this.$t("page.content.publishTime"),
          prop: "createTime",
          width: commonTableWidth.dateTimeWidth
        }
      ],
      subPackageFlag: "", //是否分包
      packageList: [],
      matDetailList: [],
      pageData: {},
      relateNoticeList: [], //相关公告列表
      schemeObj: {
        opUnitName: this.$route_query.opUnitName //发布单位
      },
      cumulativeAmount: 0, //累计金额
      projectNum: 0, //累计采购项目数
      inquiryProjectNum: 0, //询价项目数量
      competeProjectNum: 0, //竞价项目数量
      otherNoticeList: [], //该单位还在采购的公告列表
      noticeEndTime: "",
      timeObj: {
        day: 0,
        hour: 0,
        minute: 0,
        second: 0
      },
      timer: "",
      leftMinHeight: 0,
      checkFlag: "",
      supInfo: this.$store.state.user.supInfo || {},
      accessToken: this.$store.state.user.accessToken
    };
  },
  activated() {
    this.init();
  },
  deactivated() {
    this.currBreadCrumb = [];
  },
  methods: {
    init() {
      let supCodeList = [];
      if (
        this.supInfo.getSupInfoByLoginInfoRspBOList &&
        this.$route_query.purchaseType !== "4"
      ) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
          return item.supCode;
        });
      } else {
        supCodeList.push(this.propsCode);
      }
      //登录情况下查询
      if (
        this.accessToken &&
        this.supInfo.getSupInfoByLoginInfoRspBOList.length > 0
      ) {
        //查询供应商是否可参与
        qrySupJoinCheck({
          schemeId: this.$route_query.schemeId,
          supCode: this.propsCode
          // supCodeList: supCodeList,
        }).then(res => {
          if (res.data.code === "0") {
            this.checkFlag = res.data.data.checkFlag;
          }
        });
      }

      //查询公告信息及附件列表
      qryNoticeDetail({
        schemeId: this.$route_query.schemeId,
        noticeId: this.$route_query.noticeId,
        // purStep: 1,
        qryFileFlag: true
      }).then(res => {
        if (res.data.code === "0" && res.data.data) {
          this.pageData = res.data.data;
          this.$set(
            this.noticeHead[2],
            "isHidden",
            this.pageData.purStep !== "1"
          );
          this.currBreadCrumb.push({
            title: this.pageData.noticeTitle
          });
          this.schemeObj.schemeName = this.pageData.schemeName;
          this.schemeObj.schemeCode = this.pageData.schemeCode;
          this.schemeObj.noticeStartTime = this.pageData.noticeStartTime;
          this.schemeObj.isNotShowTime = this.pageData.isNotShowTime;
          this.noticeEndTime = this.pageData.noticeEndTime;
          this.timer = setInterval(this.getTime, 1000);
        }
      });
      //查询包件信息
      queryProcessSchemeMatDetail({
        supCode: this.propsCode,
        schemeId: this.$route_query.schemeId
      }).then(res => {
        if (res.data.code === "0") {
          this.subPackageFlag = res.data.data.subPackageFlag;
          if (this.subPackageFlag === "0") {
            this.packageList = [{ matDetailList: res.data.data.matDetailList }];
          } else {
            this.packageList = res.data.data.packageList;
          }
        }
      });
      //查询相关公告列表
      qryRelatedNoticeList({
        schemeId: this.$route_query.schemeId,
        noticeId: this.$route_query.noticeId
      }).then(res => {
        if (res.data.code === "0") {
          this.relateNoticeList = res.data.data;
        }
      });

      // 单位累计金额和项目数量查询
      // qryUnitAmountAndProjectNum({
      //   opUnitId: this.$route_query.opUnitId
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     this.cumulativeAmount = window.$computeUtil.getDividedToFormat(
      //       res.data.data.cumulativeAmount,
      //       10000
      //     );
      //     this.projectNum = res.data.data.projectNum;
      //     this.inquiryProjectNum = res.data.data.inquiryProjectNum;
      //     this.competeProjectNum = res.data.data.competeProjectNum;
      //   }
      // });

      //查询该单位还在采购的公告
      // listOpUnitBidNotice({
      //   pageNo: 1,
      //   pageSize: 2,
      //   purchaseType: this.$route_query.purchaseType,
      //   opUnitId: this.$route_query.opUnitId,
      //   noticeId: this.$route_query.noticeId,
      //   supCode: this.$store.state.user.supInfo.supCode,
      // }).then((res) => {
      //   if (res.data.code === "0") {
      //     this.otherNoticeList = res.data.data.rows;
      //     this.otherNoticeList.forEach((item) => {
      //       return (item.supCode = item.supCode
      //         ? item.supCode
      //         : this.propsCode);
      //     });
      //     this.$nextTick(() => {
      //       this.leftMinHeight = this.$refs.rightBox.clientHeight - 60 + "px";
      //     });
      //   }
      // });
    },
    getTime() {
      let obj =
        (new Date(this.noticeEndTime.replace(/-/g, "/")).getTime() -
          new Date().getTime()) *
        1000;
      if (obj < 0) {
        clearInterval(this.timer);
        return;
      }
      let day = Math.floor(obj / (24 * 3600 * 1000 * 1000));

      let leave1 = obj % (24 * 3600 * 1000 * 1000);
      let hour = Math.floor(leave1 / (3600 * 1000 * 1000));
      let leave2 = leave1 % (3600 * 1000 * 1000);
      let minutes = Math.floor(leave2 / (60 * 1000 * 1000));

      let leave3 = leave2 % (60 * 1000 * 1000);
      let second = Math.floor(leave3 / (1000 * 1000));

      this.timeObj.day = day;
      this.timeObj.hour = hour;
      this.timeObj.minute = minutes;
      this.timeObj.second = second;
    },

    //供应商在线投标流程
    handleProcess() {
      let url = this.$router.resolve({
        path: "/announcementDetail",
        query: {
          id: globalConfig.faqId,
          source: "1"
        }
      });
      window.open(url.href, "_blank");
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style scoped lang="scss">
.template-detail-body .detail-box .detail-info {
  width: calc(100% - 240px);
}
/deep/ .template-detail-body .detail-box {
  margin-top: 20px;
  margin-bottom: 0;
}
/deep/
  .ccui-notice-app-container-detail
  .ccui-notice-app-container-detail-body
  .ccui-notice-app-container-detail-right {
  width: inherit;
  .notice-timeout-btn {
    margin-top: 92px;
  }
  .notice-timeout-btn-bottom {
    margin-top: 32px;
  }
  .notice-timeout-btn-bottom-project {
    margin-top: 32px;
  }
}
.time {
  color: #ff142f;
  margin-left: 8px;
  margin-right: 8px;
}
</style>
